import { render, staticRenderFns } from "./ArticleSummary.vue?vue&type=template&id=74399dd8"
import script from "./ArticleSummary.vue?vue&type=script&lang=js"
export * from "./ArticleSummary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports